

import React, { useContext } from 'react';

import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';

import axios from '../axios';
import { useFormik } from 'formik';
import AppContext from '../Context/AppContext';

import Cookies from 'js-cookie';

const Login = () => {
    const { toast, setBlocked, setUser } = useContext(AppContext)

    const formik = useFormik({
        initialValues: {
            user: "",
            password: "",
        },
        validate: (data) => {
            let errors = {};
            if (!data.user) {
                errors.name = 'User is required';
            }

            if (!data.password) {
                errors.password = 'Password is required';
            }

            return errors;
        },
        onSubmit: async (data) => {
            setBlocked(true)
            try {
                const response = await axios.post('/users/login', data);
                if (response.data.success) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Login successful!', life: 3000 });
                    const maxExpiryDate = new Date(2038, 0, 19, 3, 14, 7);
                    Cookies.set('token', response.data.token, { expires: maxExpiryDate, sameSite: 'strict', path: process.env.REACT_APP_SUBFOLDER });
                    setUser(response.data.user)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Invalid credientials!', life: 3000 });
                }
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Connection failed!', life: 3000 });
            }
            setBlocked(false)
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="card flex justify-content-center w-full h-full pt-8">
            <form onSubmit={formik.handleSubmit} style={{ width: '20rem' }}>
                <h1>Login</h1>
                <div className="field">
                    <label htmlFor="user">Username</label>
                    <InputText name='user' id='user' value={formik.values.user} onChange={formik.handleChange} className={classNames('w-full', { 'p-invalid': isFormFieldValid('user') })} autoFocus />
                    {getFormErrorMessage('user')}
                </div>
                <div className="field">
                    <label htmlFor="password">Password</label>
                    <Password name='password' inputId='password' value={formik.values.password} onChange={formik.handleChange} toggleMask className={classNames('w-full', { 'p-invalid': isFormFieldValid('password') })} inputClassName='w-full' feedback={false} />
                    {getFormErrorMessage('password')}
                </div>
                <Button label="Submit" type="submit" className='w-full' />
            </form>
        </div>
    );
}

export default Login;